export default {"src":"/_next/static/media/upload.f4c49baa.svg","height":192,"width":192};